const banner = {
  "banner_01_title": "Define<span>®</span><br /><em>Classic</em>",
  "banner_01_content": "Nuansa warna alami yang menonjolkan karisma.",

  "banner_02_title": "Define<span>®</span><br /><em>Fresh</em>",
  "banner_02_content": "Inspirasi warna dari alam untuk mata cerah dan tajam.",

  "banner_button_01": "Cermin Virtual",
  "banner_button_02": "Jelajahi Deﬁne®",
}

export default banner
